import { Link } from 'react-router-dom';

function CTA() {
  return (
    <section className="cta" id="contact">
      <div className="cta-inner">
        <h2>Ready to find your place?</h2>
        <p>
          Browse available homes or get in touch for a personalized tour.
        </p>
        <Link to="/contact" className="btn-cta">Contact us</Link>
      </div>
    </section>
  );
}

export default CTA;
